// extracted by mini-css-extract-plugin
export default {"main":"main--y2etP"};